import React from 'react';
import './bits.scss';

function Tile(props) {
  const subtitleEl = props.subtitle ? (
      <div className="sgpsTile__notes">
      {props.subtitle}
      </div>
  ) : null;

  return (
    <div className="sgpsTile">
    {props.title ? (
      <div className="sgpsTile__content">
        <div className="sgpsTile__title">
          {props.title}
        </div>
        {subtitleEl}
      </div>
    ) : null}
    {props.children}
    </div>
  );
}

export default Tile;
